<template>
  <isrs-settings-dialog
    :fields="fields"
    :input-form-fields-activated="configActivated"
    :input-form-data="config"
    @formDataChanged="(config) => saveConfig(config)"
  ></isrs-settings-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import IsrsSettingsDialog from '../../components/IsrsSettingsDialog.vue'

export default {
  components: { IsrsSettingsDialog },
  data() {
    return {
      fields: [
        {
          header: 'Daily Preadvice Recipients (Every day at 00:00)',
          label: 'Daily Preadvice Recipients (example1@gls-group.com; example2@gls-group.com)',
          key: 'dailyPreadviceRecipients',
          type: String
        },
        {
          header: 'Weekly Preadvice Recipients (Every Monday at 00:00)',
          label: 'Weekly Preadvice Recipients (example1@gls-group.com; example2@gls-group.com)',
          key: 'weeklyPreadviceRecipients',
          type: String
        },
        {
          header: 'Monthly Preadvice Recipients (Every first day of the month at 00:00)',
          label: 'Monthly Preadvice Recipients (example1@gls-group.com; example2@gls-group.com)',
          key: 'monthlyPreadviceRecipients',
          type: String
        },
        {
          header: 'Enable Html attachment',
          label: 'Enable Html attachment',
          key: 'htmlAttachmentEnabled',
          type: Boolean
        }
      ],
      textsFields: [{
        label: 'Welcome Text',
        key: 'hero.headline_whitelabel',
        defaults: {
          de: 'Willkommen im {{customer}} Rücksende Portal',
          en: 'Welcome to {{customer}} return portal'
        }
      }]
    }
  },

  created() {
    this.fetchConfig()
  },

  computed: {
    ...mapGetters('returnShopPortal', [
      'configActivated',
      'config'
    ])
  },

  methods: {
    ...mapActions('returnShopPortal', [
      'fetchConfig',
      'saveConfig'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// PreadviseSettings.vue?6a90ad37